/**
 * Programmatic session alert popup.
 * Shows a styled modal alert and returns a Promise that resolves when dismissed.
 */

import Vue from "vue";
import SessionAlert from "../components/SessionAlert.vue";

/**
 * Show a session alert popup.
 * @param {string} message - The message to display
 * @returns {Promise<void>} Resolves when the user dismisses the alert
 */
export function showSessionAlert(message) {
  return new Promise((resolve) => {
    const AlertConstructor = Vue.extend(SessionAlert);

    const instance = new AlertConstructor({
      propsData: {
        visible: true,
        message: message || "Your session was ended because you logged in from another device.",
      },
    });

    // Mount to a new DOM element
    const container = document.createElement("div");
    document.body.appendChild(container);
    instance.$mount(container);

    instance.$on("dismiss", () => {
      // The component already toggled its own local `show` state (and
      // plays its leave transition) inside dismiss(); `visible` is a
      // read-only prop here, so it cannot be written back from outside.
      // Wait for transition to finish before cleanup
      setTimeout(() => {
        instance.$destroy();
        if (instance.$el && instance.$el.parentNode) {
          instance.$el.parentNode.removeChild(instance.$el);
        }
        resolve();
      }, 250);
    });
  });
}

export default { showSessionAlert };
